import { render } from "./DriveCasePublicView.vue?vue&type=template&id=8c55757e&ts=true"
import script from "./DriveCasePublicView.vue?vue&type=script&lang=ts"
export * from "./DriveCasePublicView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__